'use strict';

import Lottie from 'lottie-web';

export default {
  init() {
    const podcast = document.querySelector('.node--type-podcast-listing');
    if (podcast) {
      this.finalize(podcast);
    }
  },

  finalize(element) {
    const podcastItems = element.querySelectorAll('.podcast-item');
    podcastItems.forEach(el => {

      el.querySelectorAll('.js-lottie').forEach(lottie => {
        const animation = Lottie.loadAnimation({
          container: lottie,
          renderer:  'svg',
          loop:      false,
          autoplay:  false,
          path:      el.querySelector('.js-lottie').dataset.src,
        });

        el.addEventListener('mouseover', () => {
          animation.play();
        });

        el.addEventListener('mouseout', () => {
          animation.stop();
        });
      });
    });
  },
}
